import z from 'zod';
import { ObjectIdStringValidationSchema } from '../../../shared/ObjectId';

export const MediaResponseValidationSchema = z.object({
  fileId: ObjectIdStringValidationSchema.nullish().meta({
    description: 'Unique identifier for the uploaded file. Absent for images added by URL (e.g. stock photos).',
    example: '507f1f77bcf86cd799439011',
  }),
  url: z.url().meta({
    description: 'Image URL.',
    example: 'https://bucket-name.s3.amazonaws.com/image.jpg',
  }),
  name: z.string().meta({
    description: 'Image file name.',
    example: 'product-image.jpg',
  }),
  size: z.number().nullish().meta({
    description: 'File size in bytes.',
    example: 245678,
  }),
  width: z.number().nullish().meta({
    description: 'Image width in pixels.',
    example: 1920,
  }),
  height: z.number().nullish().meta({
    description: 'Image height in pixels.',
    example: 1080,
  }),
});
